import React from 'react';
import PropTypes from 'prop-types';

import { buildIframeSource } from '../helpers/iframe-source';
import { PostMessageService } from '../services/postmessage-service';

export class WallpaperHTML extends React.PureComponent {
  frameNode = React.createRef();

  initWallpaper = () => {
    // Initialize wallpaper message listeners and send the start signal
    PostMessageService.init(this.frameNode.current, this.props.creative);
  };

  renderTrackingTags() {
    const { creative } = this.props;

    if (!creative.impressionTrackers) return null;

    return creative.impressionTrackers.map((tracker, index) => {
      const key = `pixel-tracker-${index}`;
      return (
        <img key={key} alt={key} src={tracker} style={{ display: 'none' }} />
      );
    });
  }

  render() {
    const { creative } = this.props;

    return (
      <div className="wallpaper__html">
        <iframe
          allow="autoplay; camera"
          frameBorder="0"
          onLoad={this.initWallpaper}
          ref={this.frameNode}
          scrolling="no"
          src={buildIframeSource(creative.src)}
          title="wallpaper-frame"
          id="wallpaper-frame"
        />
        {this.renderTrackingTags()}
      </div>
    );
  }
}

WallpaperHTML.propTypes = {
  creative: PropTypes.object.isRequired,
};

export default WallpaperHTML;
